// import Image from "next/image";
import styles from "../styles/Home.module.css";
import UnitListings from "../../../components/UnitListings";
import Page from "../../../components/Page";
import AssignmentListings from "../../../components/AssignmentListings";
// import { Roboto } from "next/font/google";

const assignments: Array<Assignment> = [
    {
        name: "Assignment 1",
        description: "This is assignment 1",
        due: "2024-10-08",
        id: "1",
    },
];

export default function Assignments() {
    return (
        <>
            <head>
                <title>Math with Maki</title>
                <meta name="description" content="Math with Maki" />
                <link rel="icon" href="/favicon.ico" />
            </head>
            <Page href="math150">
                {/* <h2>Assignments</h2> */}
                <AssignmentListings assignments={assignments} />
            </Page>
        </>
    );
}
